
import log from 'loglevel';
var graph = require('@microsoft/microsoft-graph-client');

export const getAuthenticatedClient = (accessToken) => {
    log.info(`getAuthenticatedClient @ authClient`);

        try {
            
            const client = graph.Client.init({
            authProvider: (done) => {
                done(null, accessToken.accessToken);
            }
            });
            return client;

        } catch (error) {
            log.error(`error / getAuthenticatedClient @emailServiceSend ${JSON.stringify(error)}`);
        } finally {
            log.info(`finally / getAuthenticatedClient @emailServiceSend`);
        } 
}
